module.exports = __webpack_public_path__ + "static/img/puxing_logo.080c330a.png";